import { useLocation, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Tabs, { TabProps } from "./Tabs";

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const tabs = useMemo<TabProps[]>(
    () => [
      {
        name: "/",
        title: t<string>("Calendar"),
      },
      {
        name: "/table",
        title: t<string>("Unapproved bookings"),
      },
      {
        name: "/configurations",
        title: t<string>("Settings"),
      },
    ],
    [t]
  );

  const onActiveChange = (name: string) => {
    navigate(name);
  };

  return (
    <Tabs
      tabs={tabs}
      onActiveChange={onActiveChange}
      active={location.pathname}
      className="mb-4"
    />
  );
};

export default Navigation;
